define('models/commons/locale',[
    'underscore',
    'backbone',
    // 'epoxy',
    // 'models/computed-model'
], function(_, Backbone) {

    var MLocale = Backbone.Epoxy.Model.extend({
        // idAttribute: 'code',
        computeds: {
            label: function() {
                return this.get('name');
            },
            value: function() {
                return this.id;
            }
        },


        getCode: function(sep) {
            sep = sep || '-';
            return this.get('code') + sep + this.get('territory');
        }
    });

    // Return the model for the module
    return MLocale;
});

